import env from 'utils/env';
import {
  flattenProducts,
  getSocialCartProducts,
  getSocialCartVariants,
} from '@nexus/fff-cart';
import requestJson from './requestJson';
import request from './request';

export const getInviteData = (inviteCode) => {
  const headers = { Accept: '*' };
  return requestJson(
    `${env.aceApi}/teams/invite-code/${inviteCode}`,
    'GET',
    headers
  );
};

export const getTeamId = (campaignId, campaignWindow) => {
  const headers = { Accept: '*' };
  return requestJson(
    `${env.aceApi}/1/teams/campaigns/${campaignId}/windows/${campaignWindow}`,
    'GET',
    headers
  );
};

export const getInvitationsAndTeam = (campaignId, campaignWindow) =>
  request(
    `${env.aceApi}/1/teams/members/campaigns/${campaignId}/windows/${campaignWindow}`,
    'GET'
  );

export const createTeamRequest = (campaignId, campaignWindow) => {
  const headers = { Accept: '*' };
  return requestJson(
    `${env.aceApi}/1/teams/campaigns/${campaignId}/windows/${campaignWindow}`,
    'POST',
    headers
  );
};

export const sendInviteRequest = (data) => {
  const headers = {
    Accept: '*',
    'Content-Type': 'application/json',
  };
  return requestJson(
    `${env.aceApi}/1/teams/invite`,
    'POST',
    headers,
    JSON.stringify(data)
  );
};

export const getTeamCarts = async (teamId) => {
  const headers = { Accept: '*' };
  const requestUrl = `${env.aceApi}/1/carts/teams/${teamId}`;
  const response = await requestJson(requestUrl, 'GET', headers);
  const {
    variantIdProductMap,
    variants: variantsUsers,
    userIds,
    products: productsWithVariants,
  } = response.data.items[0];
  const { products, variants } = flattenProducts(productsWithVariants);
  const cartVariants = getSocialCartVariants(variantsUsers, variants, products);
  const cartProducts = getSocialCartProducts(
    variantIdProductMap,
    variantsUsers
  );

  return { cartProducts, userIds, cartVariants, products, variants };
};

export const getTeamAvatars = (userIds) => {
  const requestUrl = `${env.avatarApi}/shop-users/avatars-resolver`;
  const data = JSON.stringify({
    shopUserIds: userIds,
    withoutImageSize: false,
  });
  return request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
};

export const reedemInviteAndJoinTeam = (inviteCode) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return request(
    `${env.registerApi}/2/social/invites/${inviteCode}/redeem`,
    'PUT',
    headers,
    '',
    false,
    false
  );
};
